  <template>
  <div>
    <div class="parent-default-child-card position-relative overflow-hidden rounded-5">
      <div
        v-if="is_empty"
        class="empty-class-overlay w-100 h-100 d-flex justify-content-start align-items-center nowrap"
      >
        <!-- AVATAR -->
        <div class="avatar avatar-square avatar_md mr-2">
          <img v-lazy="localImg('avatar8.png')" alt class="avatar-img">
        </div>

        <!-- TEXT CONTENT -->
        <div class="text-content brand_white font-weight-500">Not connected to a child at the moment</div>
      </div>

      <!-- CHILD INFO  -->
      <div class="child-card d-flex justify-content-between align-items-center nowrap">
        <div
          class="left d-flex justify-content-start align-items-center"
          :class="is_empty ? 'invisible' : null"
        >
          <div
            class="avatar avatar-square avatar_md mr-2"
            :class="is_loading ? 'skeleton-loader' : 'color_white_bg'"
          ></div>

          <div class="child-info">
            <div
              class="name font-weight-bold"
              :class="is_loading ? 'skeleton-loader' : 'color_white_bg'"
            ></div>
            <div
              class="code color_grey_dark"
              :class="is_loading ? 'skeleton-loader' : 'color_white_bg'"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChildDefaultCard",
  props: {
    is_empty: Boolean,
    is_loading: Boolean
  }
};
</script>

<style lang="scss">
.parent-default-child-card {
  padding: 12px;

  .empty-class-overlay {
    position: absolute;
    left: 0;
    top: 0;
    background: rgba($brand_primary, 0.7);
    padding: 20px 15px;

    .avatar {
      position: relative;
      left: 2px;
      margin-right: 10px;
    }
    .text-content {
      font-size: 13.5px;
      line-height: 19px;
    }
  }

  .card-label {
    top: 0;
    left: 0;
    height: 100%;
    width: 6px;
  }

  .child-card {
    .left {
      .avatar {
        margin-left: 10px;

        @include breakpoint_max(lg) {
          margin-left: 5px;
        }
      }
    }
  }

  .name {
    width: 140px;
    height: 22px;
    margin-bottom: 3px;

    @include breakpoint_max(lg) {
      font-size: 13px;
      line-height: 18px;
    }

    @include breakpoint_max(md) {
      font-size: 14px;
      line-height: 21px;
    }
  }

  .code {
    width: 100px;
    height: 20px;

    @include breakpoint_max(lg) {
      font-size: 11px;
    }

    @include breakpoint_max(md) {
      font-size: 12px;
    }
  }
}
</style>
